<template>
    <div class="mainDiv">
        <div class="top-portion">
            <p class="headerText">
                Krishify Business Suite provides a 360° view of the farming community, as well as non-farmers like
                retailers, vet consultants, and traders, making it easier for brands to identify and target their
                potential customers.
            </p>
        </div>
        <div class="image-card">
            <img height="100%" width="100%" src="../../../assets/LandingPage/AboutScreenDesktop.png" alt="" />
            
        </div>
        <div class="image-cardMobile">
            <img height="100%" width="100%"  src="../../../assets/LandingPage/AboutScreenMobile.png" alt="" />
        </div>
    </div>
</template>

<script>
import statisticCard from "./statistic-card.vue";

export default {
    name: "aboutScreenKrishify",

    components: {
        "statistic-card": statisticCard,
    },
};
</script>

<style lang="scss" scoped>
.mainDiv {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    // justify-content: space-between;
    margin: 0px auto;
    gap: 5px;
    text-align: center;
    align-items: center;
}
.image-cardMobile{
    width: 80%;
}
.headerText {
    max-width: 973px;
    font-weight: 400;
    font-size: 18px;
    line-height: 140%;
    text-align: center;
    color: #797e79;
    margin-bottom: 0px;
  
}

.image-card {
    height: 504px;

    background: #f8f9f8;
    border-radius: 8px;
}
.top-portion {
    margin-bottom: 60px;
}
.image-cardMobile {
}
@media all and (max-width: 1024px) {
    .image-card {
        display: none;
    }
}
@media all and (max-width: 1024px) {
    .top-portion {
        margin-bottom: 32px;
    }
}
@media all and (min-width: 1024px) {
    .image-cardMobile {
        display: none;
    }
}
@media all and (max-width: 1024px) {
    .headerText {
        text-align: start;
        // max-width: 320px;

        // display: none;
    }
}
</style>
